<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="frontmatter_TOC-head">Contents</p>
<div class="tocimage">
<img alt="" src="image/Dragon_.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><a href="#/x13175_T2"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Chi and the Seven-Headed Dragon </span>  <br/>Chinese legend <span class="frontmatter_TOC-chapter-page-number">6</span></a></p>
<div class="tocimage" style="margin-top:0.4em;">
<img alt="" src="image/Inanna_Nishnibur_.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T3" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Inanna and the Box of Monsters</span>  <br/>Sumerian myth <span class="frontmatter_TOC-chapter-page-number">15</span></span></p>
<div class="tocimage">
<img alt="" src="image/Red_Riding_Hood_type_girl.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T4" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">The Wolf in the Bed </span>  <br/>French folktale <span class="frontmatter_TOC-chapter-page-number">27</span></span></p>
<div class="tocimage">
<img alt="" src="image/Greek_Woman_2.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T5" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Telesilla and the Gates of Argos </span>  <br/>Greek legend <span class="frontmatter_TOC-chapter-page-number">35</span></span></p>
<div class="tocimage">
<img alt="" src="image/Ten_arms_2.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T6" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Durga and the Demon </span>  <br/>Indian myth <span class="frontmatter_TOC-chapter-page-number">40</span></span></p>
<div class="tocimage">
<img alt="" src="image/young_man_as_sun.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T7" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Kopecho and the Two Suns </span>  <br/>Venezuelan myth <span class="frontmatter_TOC-chapter-page-number">46</span></span></p>
<div class="tocimage" style="width:1.5em;">
<img alt="" src="image/Girl_Carrying_Dish.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T8" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Mbango and the Whirlpool </span> <br/>Cameroonian folktale <span class="frontmatter_TOC-chapter-page-number">52</span></span></p>
<div class="tocimage" style="margin-top:-0.2em;">
<img alt="" src="image/viking_girl_.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T9" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Hervor and the Cursed Sword </span> <br/>Norse legend <span class="frontmatter_TOC-chapter-page-number">61</span></span></p>
<div class="tocimage" style="width:1.3em;margin-top:-0.2em;">
<img alt="" src="image/Baba_Yaga_Hut_.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T10" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Visiting Baba Yaga </span> <br/>Russian folktale <span class="frontmatter_TOC-chapter-page-number">68</span></span></p>
<div class="tocimage" style="margin-top:0.8em;">
<img alt="" src="image/Honeysucklewoodbine.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T11" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Aliquipiso and the Cliffs</span><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2"> </span> <br/>American Indian legend <span class="frontmatter_TOC-chapter-page-number">78</span></span></p>
<div class="tocimage">
<img alt="" src="image/Girl_Swimming_.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T12" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">Tokoyo and the Skin Rope </span> <br/>Japanese legend <span class="frontmatter_TOC-chapter-page-number">84</span></span></p>
<div class="tocimage">
<img alt="" src="image/Giant_dragging_girl_.jpg"/>
</div>
<p class="frontmatter_TOC-chapter-head"><span href="#/x13175_T13" title="Link target outside of Sample"><span class="frontmatter_TOC-chapter-number _idGenCharOverride-2">The Giant’s Heart </span> <br/>Scottish folktale <span class="frontmatter_TOC-chapter-page-number">95</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// x13175_T1.vue?d4ea9518